import { render, staticRenderFns } from "./editItemReleaseViewList.vue?vue&type=template&id=07cc2d9c&scoped=true"
import script from "./editItemReleaseViewList.vue?vue&type=script&lang=js"
export * from "./editItemReleaseViewList.vue?vue&type=script&lang=js"
import style0 from "./editItemReleaseViewList.vue?vue&type=style&index=0&id=07cc2d9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cc2d9c",
  null
  
)

export default component.exports